<template>
  <div class="map-item-content">
    <div class="map-title">
      {{title}}
    </div>
    <amchart-map :locations="locations" v-if="locations.length"></amchart-map>
  </div>
</template>

<script>

import AmchartMap from '@/components/amchartmap/index.vue'

export default {
  uuid: "00000000-0000-0000-0000-000000100002",
  components: {
    AmchartMap
  },
  props: [
    'datamodel',
  ],
  data() {
    return {
      mapid: undefined
    }
  },
  computed: {
    title() {
      if(this.$i18n.locale == 'zh-CN'){
        return this.datamodel.zhlabel.replace(/\//g, ' / ')  
      }
      return this.datamodel.enlabel.replace(/\//g, ' / ')
    },
    locations() {
      let location = this.datamodel.value
      return [location]
    }
  },
  methods: {
    
  },
  created() {
    this.mapid = new Date().getTime()
  },
  mounted() {

  }
}
</script>
<style lang="scss">

.map-item-content {
  // margin: 16px;
  margin: 16px 0;
  // margin-top: 32px;
  height: 295px;
  overflow: hidden;
  .map-title {
    // margin-top: 16px;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.04em;
    text-align: left;
    color: #8C8C8C;
    width: 120px;

    padding-bottom: 16px;
    // line-height: 40px;
  }
}

</style>
